import { EducationalCard } from '../types'

export const educationalCards: EducationalCard[] = [
  {
    id: 'what-is-ai',
    title: 'Что такое ИИ?',
    content: 'Искусственный интеллект (ИИ) — это компьютерная программа, которая может выполнять задачи, обычно требующие человеческого разума.',
    analogy: 'ИИ как очень умный помощник в библиотеке, который знает, где найти любую книгу и может быстро ответить на ваши вопросы.',
    difficulty: 'beginner',
    completed: false
  },
  {
    id: 'how-ai-understands',
    title: 'Как ИИ понимает язык?',
    content: 'ИИ изучает язык, читая миллионы текстов и находя закономерности в том, как слова связаны друг с другом.',
    analogy: 'Представьте опытного телефониста на старой АТС, который за годы работы запомнил, кто с кем обычно говорит, и может соединить вас с нужным человеком.',
    difficulty: 'beginner', 
    completed: false
  },
  {
    id: 'training-ai',
    title: 'Как обучают ИИ?',
    content: 'ИИ обучается на примерах, как студент, который читает учебники и решает задачи, чтобы сдать экзамен.',
    analogy: 'Это как обучение молодого радиста в армии — сначала он слушает много передач, учится различать сигналы, а потом сам начинает работать на рации.',
    difficulty: 'intermediate',
    completed: false
  },
  {
    id: 'ai-limitations',
    title: 'Что ИИ НЕ умеет?',
    content: 'ИИ не может думать как человек, не имеет сознания и может ошибаться. Он работает только с информацией, которую получил при обучении.',
    analogy: 'ИИ как справочник в библиотеке — очень полезный, но в нём может быть устаревшая информация, и он не может дать совет, основанный на жизненном опыте.',
    difficulty: 'intermediate',
    completed: false
  },
  {
    id: 'good-prompts',
    title: 'Как правильно общаться с ИИ?',
    content: 'Чтобы получить хороший ответ от ИИ, нужно задавать чёткие, подробные вопросы с контекстом.',
    analogy: 'Это как обращение к справочной службе по телефону — чем точнее вы объясните, что вам нужно, тем лучше вам помогут.',
    difficulty: 'beginner',
    completed: false
  },
  {
    id: 'ai-safety',
    title: 'Безопасность при работе с ИИ',
    content: 'Важно помнить, что ИИ может ошибаться, поэтому критически важную информацию нужно проверять из других источников.',
    analogy: 'Как с советами соседа — они могут быть полезными, но для важных решений лучше посоветоваться с врачом или другим специалистом.',
    difficulty: 'beginner',
    completed: false
  }
]

export const getCardsByDifficulty = (difficulty: 'beginner' | 'intermediate' | 'advanced') => {
  return educationalCards.filter(card => card.difficulty === difficulty)
}

export const getCardById = (id: string) => {
  return educationalCards.find(card => card.id === id)
}